<template>
  <div class="desc-attachment-wrapper">
    <div class="container">
      <div class="row margin-bottom-20 ">
        <div class="col-lg-5">
          <CalendarActivityDescription v-if="sessionType === sessionTypes.INDIVIDUAL"
            :update-activity-description="updateActivityDescription" :description="description"
            :activity-id="activityId" />
        </div>
        <div class="col-lg-3">
          <DeleteSessionModal v-if="activityInfo.type === sessionTypes.INDIVIDUAL" :activity-id="activityId"
            :delete-activity="deleteActivity" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CalendarActivityDescription from '@/components/calendar-activity/CalendarActivityDescription'
import { SESSION_TYPES } from '@/constants/SessionConsts'
import { FULL_DATE_TIME_FORMAT } from '@/constants/DateConstants'
import DeleteSessionModal from '@/components/calendar-activity/DeleteSessionModal'

export default {
  name: 'DescAttachmentDel',
  props: [
    'attachments',
    'activityId',
    'sessionType',
    'updateActivityDescription',
    'description',
    'summary',
    'currentMetric',
    'activityInfo',
    'deleteActivity'
  ],
  data() {
    return {
      fullDateTimeFormat: FULL_DATE_TIME_FORMAT,
      sessionTypes: SESSION_TYPES,
    }
  },
  components: {
    CalendarActivityDescription,
    DeleteSessionModal
  }
}
</script>

<style lang="scss" scoped>
.desc-attachment-wrapper {
  width: 100%;
  height: auto;
  margin: 30px 0;
  padding: 30px 0;
  border-top: 1px solid #54545B;
  border-bottom: 1px solid #54545B;
}
</style>
